<template>
  <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
  <BaseModal
    v-cloak
    :modal-id="`closeDialogModal-${id}`"
    :header-text="$t('End conversation')"
    :cancel-button-text="$t('Cancel')"
    :action-button-text="$t('End')"
    :confirm-button-text="$t('End conversation')"
    :disabled="!canEndConversation"
    :is-open="open"
    :saving-text="$t('Ending conversation...')"
    :save-state="modalSaveState"
    @cancel="resetModal"
    @positive-response="closeDialog"
    @negative-response="resetModal"
  >
    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <BaseHtmlForm accept-charset="UTF-8" append-user-and-account>
      <br />
      <p>
        {{
          $t(
            'Once you end this conversation, the external worker will no longer be able to reply or submit bills. Make sure to only end this conversation if all expected bills have been submitted.',
          )
        }}
      </p>
      <p>
        {{
          $t('Consider writing a final message to :freelancerName:', {
            freelancerName: freelancerName,
          })
        }}
      </p>
      <textarea
        id="textarea-message"
        v-model="closeMessage"
        :placeholder="$t('Type your message.')"
        name="message"
        class="form-control"
        rows="3"
      ></textarea>
    </BaseHtmlForm>
    <WdsCheckbox
      v-model:checked="useAsDefaultMessage"
      :label="
        $t('Save as :new standard answer', {
          new: defaultCloseMessage ? $t('new') : '',
        })
      "
      class="tw-mt-2.5"
    />

    <template #additionalButtons>
      <WdsStack direction-row gap-sm class="tw-pl-6">
        <strong>
          {{ $t('All expected bills have been submitted') }}
        </strong>
        <div class="tw-mt-1">
          <WdsCheckbox v-model:checked="canEndConversation" />
        </div>
      </WdsStack>
    </template>
  </BaseModal>
</template>

<script>
import { WdsStack, WdsCheckbox } from '@worksome/wds-components'
import axios from 'axios'
import ax from '@/api/axios-instance'
import { ModalSaveState } from '@/utils/enum'

export default {
  components: {
    WdsCheckbox,
    WdsStack,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    open: {
      type: Boolean,
      default: false,
    },
    defaultCloseMessage: {
      type: String,
      default: null,
    },
    freelancerName: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      modalSaveState: null,
      useAsDefaultMessage: false,
      closeMessage: null,
      canEndConversation: false,
    }
  },

  watch: {
    useAsDefaultMessage() {
      window.onbeforeunload = null
    },
  },

  created() {
    this.cAxios = axios.create({
      baseURL: '',
      headers: ax.headers,
    })
  },

  mounted() {
    this.closeMessage = this.defaultCloseMessage
  },

  methods: {
    async closeDialog() {
      try {
        this.modalSaveState = ModalSaveState.SAVING
        const { data } = await axios.put(`/messages/${this.id}`, {
          isajax: 1,
          message: this.closeMessage,
          message_type: 'closerejectdialog',
          use_as_default_closing_job_message: this.useAsDefaultMessage,
        })
        if (data.status === 'ok') {
          this.$emit('dialog-closed')
          this.$emit('modal-closed')
          this.$emit('success')
          this.modalSaveState = ModalSaveState.SAVED
          this.modalOpen = false
        } else {
          this.modalSaveState = ModalSaveState.FAILED
          if (
            confirm(
              this.$t(
                'An error occurred during the process of saving. Do you want to reload the page?',
              ),
            )
          ) {
            location.reload()
          }
        }
      } catch (exception) {
        this.modalSaveState = ModalSaveState.FAILED
        alert(this.$t('Error occurred. The action was not completed'))
      }
    },
    resetModal() {
      this.modalOpen = false
      this.$emit('dialog-closed')
      this.$emit('modal-closed')
      this.useAsDefaultMessage = false
    },
  },
}
</script>
